import { mediaRef } from '@/services/mediaAssets';

const coverImage = mediaRef('adventures/holiday-hells-kitchen-2023.png');
const heroImage = mediaRef('adventures/reckon-ball-2023-hells-kitchen-no-text.png');
const penthouseCocktailHourImage = mediaRef('adventures/reckon-ball-2023-penthouse-cocktail-hour.jpg');
const hellsKitchenDinnerImage = mediaRef('adventures/reckon-ball-2023-hells-kitchen-dinner.jpg');
const waterfrontAfterPartyImage = mediaRef('adventures/reckon-ball-2023-waterfront-after-party.jpg');
const hellsKitchenSelfieImage = mediaRef('adventures/reckon-ball-2023-hells-kitchen-selfie.jpg');
const tikiTntAfterPartyImage = mediaRef('adventures/reckon-ball-2023-tiki-tnt-after-party.jpg');
const beefWellingtonImage = mediaRef('adventures/reckon-ball-2023-hells-kitchen-beef-wellington.jpg');
const privateDiningRoomImage = mediaRef('adventures/reckon-ball-2023-hells-kitchen-private-dining-room.jpg');
const giftExchangeDisplayImage = mediaRef('adventures/reckon-ball-2023-gift-exchange-display.jpg');
const penthouseBottlesImage = mediaRef('adventures/reckon-ball-2023-penthouse-bottles.jpg');
const penthouseSpreadImage = mediaRef('adventures/reckon-ball-2023-penthouse-spread.jpg');
const cocktailHourSantaImage = mediaRef('adventures/reckon-ball-2023-cocktail-hour-santa.jpg');
const cocktailHourCoupleImage = mediaRef('adventures/reckon-ball-2023-cocktail-hour-couple.jpg');
const shellfishStationImage = mediaRef('adventures/reckon-ball-2023-hells-kitchen-shellfish-station.jpg');

export default {
  slug: '2023',
  year: 2023,
  title: 'Reckon Ball at The Wharf',
  theme: 'The Gathering',
  coverImage,
  location: { city: 'Washington', state: 'D.C.', neighborhood: 'The Wharf' },
  hero: {
    eyebrow: 'Reckon Ball 2023',
    title: 'The Gathering',
    subtitle: "Pendry Washington DC and Hell's Kitchen",
    summary: 'The second Reckon Ball expanded into a full evening at The Wharf, beginning in a penthouse suite and continuing through private dining and a waterfront after-party.',
    image: heroImage,
    imageAlt: "The Reckon Crew arriving at Hell's Kitchen at The Wharf for Reckon Ball 2023",
  },
  hotel: {
    name: 'Pendry Washington DC',
    location: 'The Wharf, Washington, D.C.',
    overnightStay: true,
    summary: 'The Pendry became the center of the celebration, beginning with cocktails and the annual gift exchange in a penthouse suite overlooking The Wharf.',
  },
  timeline: [
    { title: 'Check-In', location: 'Pendry Washington DC' },
    { title: 'Penthouse Cocktail Hour', location: 'Pendry Penthouse Suite' },
    { title: 'Gift Exchange', location: 'Pendry Penthouse Suite' },
    { title: 'Dinner', location: "Hell's Kitchen" },
    { title: 'Waterfront After-Party', location: 'Tiki TNT & Potomac Distilling Company' },
    { title: 'Overnight Stay', location: 'Pendry Washington DC' },
  ],
  experiences: [
    {
      id: 'penthouse', eyebrow: 'The Gathering Begins', title: 'Penthouse Cocktail Hour', venue: 'Pendry Penthouse Suite', summary: 'Cocktails and the annual gift exchange brought the crew and their guests together above The Wharf before dinner.', image: penthouseCocktailHourImage, imageAlt: 'Reckon Ball gifts and ice sculpture arranged in the Pendry penthouse overlooking The Wharf',
    },
    {
      id: 'gift-exchange', eyebrow: 'Annual Tradition', title: 'Gift Exchange', venue: 'Pendry Penthouse Suite', summary: 'The small exchange that began in 2022 grew into a larger centerpiece of the Reckon Ball gathering.',
    },
    {
      id: 'after-party', eyebrow: 'After Hours', title: 'Waterfront After-Party', venue: 'Tiki TNT & Potomac Distilling Company', summary: 'The celebration continued along the waterfront after dinner.', image: tikiTntAfterPartyImage, imageAlt: 'Reckon Ball guests sharing a tropical cocktail at Tiki TNT during the waterfront after-party',
    },
  ],
  traditions: [
    { type: 'gift-exchange', title: 'Gift Exchange', firstYear: 2022 },
    { type: 'cocktail-hour', title: 'Cocktail Hour', firstYear: 2022 },
    { type: 'overnight-stay', title: 'Overnight Stay', firstYear: 2022 },
  ],
  dining: {
    restaurant: "Hell's Kitchen",
    date: '2023-12-16',
    location: 'The Wharf, Washington, D.C.',
    privateDining: true,
    summary: "Hell's Kitchen hosted the crew and their guests for a private dinner at The Wharf.",
    images: [
      {
        src: hellsKitchenDinnerImage,
        alt: "Reckon Crew and guests gathered around the dinner table at Hell's Kitchen",
      },
    ],
    menu: {
      eventTitle: 'Reckon Ball at The Wharf',
      year: 2023,
      restaurant: "Hell's Kitchen",
      location: 'The Wharf, Washington, D.C.',
      image: beefWellingtonImage,
      imageAlt: "Beef Wellington with lobster tail and shaved truffles at Hell's Kitchen",
      imageCaption: 'Beef Wellington, lobster tail, and shaved truffles from the keepsake menu.',
      sections: [
        { title: 'Passed Canapes', serviceStyle: 'passed', items: [{ name: 'Grilled Cheese' }, { name: 'Wagyu Meatballs' }, { name: 'Pan-Seared Scallops' }] },
        { title: 'Shellfish Station', items: [{ name: 'Shellfish Tower' }] },
        { title: 'First Course', serviceStyle: 'choice', items: [{ name: 'Caesar Salad' }, { name: 'Seasonal Soup' }, { name: 'Shrimp Cocktail' }] },
        { title: 'Main Course', serviceStyle: 'choice', items: [{ name: 'Beef Wellington' }, { name: 'Chicken Scallopini' }, { name: 'Crispy Skin Salmon' }, { name: 'Vegetarian Risotto' }] },
        { title: 'Enhancements', items: [{ name: 'Lobster Tail', premium: true }, { name: 'Foie Gras', premium: true }, { name: 'Shaved Truffles', premium: true }] },
        { title: 'Dessert', serviceStyle: 'choice', items: [{ name: 'Sticky Toffee Pudding' }, { name: 'Seasonal Cheesecake' }] },
      ],
    },
  },
  signatureExperience: { eyebrow: 'A New Tradition', title: 'The Penthouse Gathering', summary: 'The Pendry penthouse gave cocktail hour and the gift exchange a setting that made the second Reckon Ball feel like a true gathering.' },
  memories: [
    { tone: 'subtle', text: "Hell's Kitchen lived up to its name, serving an unforgettable dinner and just enough excitement to remind everyone why it is always useful to know who to call." },
  ],
  gallery: [
    {
      src: penthouseCocktailHourImage,
      alt: 'Reckon Ball gifts and ice sculpture arranged in the Pendry penthouse overlooking The Wharf',
      caption: 'The penthouse was ready for cocktail hour and the annual gift exchange above The Wharf.',
    },
    {
      src: giftExchangeDisplayImage,
      alt: 'Wrapped gifts arranged around the Reckon Ball ice sculpture in the Pendry penthouse',
      caption: 'The growing gift exchange filled the penthouse with presents.',
    },
    {
      src: penthouseBottlesImage,
      alt: 'Celebration bottles displayed in front of the Reckon Ball ice sculpture',
      caption: 'A couple of special bottles joined the penthouse celebration.',
    },
    {
      src: penthouseSpreadImage,
      alt: 'Cocktail-hour food spread and bottles in the Pendry penthouse',
      caption: 'The cocktail-hour spread was ready before the evening moved to dinner.',
    },
    {
      src: cocktailHourSantaImage,
      alt: 'Two Reckon Ball guests together during the penthouse cocktail hour',
      caption: 'Holiday spirit during cocktail hour in the penthouse.',
    },
    {
      src: cocktailHourCoupleImage,
      alt: 'Two Reckon Ball guests seated together beside the gift exchange',
      caption: 'Gathering together before dinner with the gift exchange in the background.',
    },
    {
      src: hellsKitchenDinnerImage,
      alt: "Reckon Crew and guests gathered around the dinner table at Hell's Kitchen",
      caption: "The Reckon Crew and guests gathered for dinner at Hell's Kitchen.",
    },
    {
      src: waterfrontAfterPartyImage,
      alt: "Five Reckon Crew members on the deck outside the private dining room at Hell's Kitchen",
      caption: "The crew on the deck just outside the private dining room at Hell's Kitchen.",
    },
    {
      src: hellsKitchenSelfieImage,
      alt: "Holiday selfie in front of a Gordon Ramsay portrait at Hell's Kitchen",
      caption: "A festive selfie with Gordon Ramsay keeping watch at Hell's Kitchen.",
    },
    {
      src: tikiTntAfterPartyImage,
      alt: 'Reckon Ball guests sharing a tropical cocktail at Tiki TNT during the waterfront after-party',
      caption: 'A tropical cocktail and plenty of holiday spirit at Tiki TNT.',
    },
    {
      src: beefWellingtonImage,
      alt: "Beef Wellington with lobster tail and shaved truffles at Hell's Kitchen",
      caption: 'Beef Wellington, lobster tail, and shaved truffles from the 2023 dinner menu.',
    },
    {
      src: shellfishStationImage,
      alt: "Shellfish tower and accompaniments at the Hell's Kitchen dinner",
      caption: "The shellfish station at Hell's Kitchen was ready for the private dinner.",
    },
    {
      src: privateDiningRoomImage,
      alt: "Reckon Crew and guests seated around the private dining table at Hell's Kitchen",
      caption: "The full table gathered inside the private dining room at Hell's Kitchen.",
    },
  ],
  relatedYears: [2022, 2024, 2025],
  tags: ['reckon-ball', 'gift-exchange', 'private-dining', 'after-party'],
};
